export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas encore analysée"])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indisponible"])}
      },
      "en": {
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not yet analyzed"])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unavailable"])}
      }
    }
  })
}
